import styled from '@emotion/styled'

import { Space } from '../../atoms'

export const StyledContainer = styled(Space)`
  background: var(--White98);
`
